<template>
  <el-row
    type="flex"
    justify="center"
  >
    <el-col
      :xs="{ span: 20 }"
      :sm="{ span: 20 }"
      :md="{ span: 16 }"
    >
      <el-container class="card auto-width">
        <el-row>
          <el-col class="py-2">
            <el-steps
              :active="4"
              finish-status="success"
              align-center
            >
              <el-step />
              <el-step />
              <el-step />
              <el-step />
              <el-step />
            </el-steps>
          </el-col>
          <el-col
            :span="20"
            :offset="2"
            class="mt-2"
          >
            <el-row
              type="flex"
              justify="space-between"
              :gutter="9"
              class="container"
            >
              <el-col>
                <el-container>
                  <p style="text-align:left; font-size: 36px;" v-show="selectedAction == 'instorewaitlist'">
                    During the instore process you are required to stay instore.
                    <br><br>
                    Shop our racks for deals 50%-94% off retail prices.
                  </p>
                  <p style="text-align:left; font-size: 36px;" v-show="selectedAction == 'dropoff'">
                    Our store is limited in space.
                    <br>
                    Your items must be picked up within 24 hours after receiving the text message that they have been processed or your items may be donated.
                  </p>
                </el-container>
              </el-col>
            </el-row>
            <el-row class="mt-3 mb-2">
              <el-col
                class="text-center"
              >
                <el-button
                  type="info"
                  class="form-button"
                  :disabled="loading"
                  @click.prevent="createTransaction()"
                >
                  <span v-if="!loading">{{ strings.back.label }}</span>
                  <span v-if="loading">{{ strings.back.loading }}</span>
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TransactionPage',
  data() {
    return {
      loading: false,
      strings: {
        remorse: 'I want my items back',
        donate: 'Donate or Recycle',
        back: {
          label: 'I have read and agree to the above terms and conditions.',
          loading: 'Please wait...'
        },
        actions: {
          remorse: 'buyers_remorse',
          donate: 'recycle_or_donate'
        }
      }
    };
  },
  computed: {
    ...mapGetters('shopper', ['selectedShopper']),
    ...mapGetters('shopper', ['selectedAction']),
    ...mapGetters('shopper', ['selectedBinNumber']),
    ...mapGetters('shopper', ['isNewShopper'])
  },
  async mounted() {
    // Take user back to search if there is no selected shopper in the store
    if (!this.$store.getters['shopper/selectedShopper']) {
      this.$router.push('/search');
    }
  },
  methods: {
    async createTransaction() {
      // Click flooding protection
      if (this.loading) { return; }

      // Only allowed actions
      // const allowed = Object.values(this.strings.actions);
      // if (!allowed.includes(action)) { return; }

      try {
        // This user id will come from the store when views are connected
        const { id } = this.selectedShopper;
        const action = this.selectedAction;
        const binNumber = this.selectedBinNumber;
        const isNewShopper = this.isNewShopper;
        let selectedTagIds = this.$store.getters['tags/getSelectedTags'].map((tag) => tag.id);
        console.log(selectedTagIds);

        if (action === 'dropoff') {
          const eSignatureTagId = this.$store.getters['tags/getTags'].find(tag => tag.key === 'E_SIGNATURE').id;
          console.log(eSignatureTagId);

          const hasESignatureTag = selectedTagIds.includes(eSignatureTagId);
          const shouldHaveESignatureTag = this.$store.getters['shopper/dropoffDonateRemaining'];

          if (shouldHaveESignatureTag && !hasESignatureTag) {
            selectedTagIds.push(eSignatureTagId);
            console.log('adding e-signature tag');
          } else if (!shouldHaveESignatureTag && hasESignatureTag) {
            selectedTagIds = selectedTagIds.filter(tagId => tagId !== eSignatureTagId);
            console.log('removing e-signature tag');
          }
        }

        // Disable UI items & reset message
        // this.loading = true;
        // Api call
        const txData = await this.$store.dispatch('shopper/createTransaction', { action, id, binNumber, isNewShopper, selectedTagIds });
        console.log(txData);
        // // Update stored shopper with this Tx and send user to Receipt Page
        // this.$store.dispatch('shopper/storeSelected', { transaction: txData });
        // // Unlock UI elements
        // this.loading = false;
        // // Thank you message
        // const storedShopper = this.$store.getters['shopper/selectedShopper'];
        // setTimeout(() => this.$router.push('/home'), 2000);
        // const { value } = await this.$swal({
        //   type: 'success',
        //   title: 'Thank You!',
        //   allowEscapeKey: false,
        //   allowOutsideClick: false,
        //   showConfirmButton: false,
        //   timer: 5000,
        //   // eslint-disable-next-line camelcase
        //   html: `<b>${storedShopper.first_name}</b>, thanks for shopping at labelswap.`
        // });

        // Unlock UI elements
        this.loading = false;
        // Thank you message
        const storedShopper = this.$store.getters['shopper/selectedShopper'];
        setTimeout(() => this.$router.push('/action'), 2000);
        const { value } = await this.$swal({
          type: 'success',
          title: 'Thank You!',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          timer: 5000,
          // eslint-disable-next-line camelcase
          html: `<b>${storedShopper.first_name}</b>, thanks for shopping at labelswap.`
        });

      } catch (error) {
        this.loading = false;
       
        if (error.response.status === 400){
          await this.$swal({
            type: 'error',
            title: 'Error',
            text: error.response.data.error
          });
        }
        this.$router.push('/action');
      }
    }
  },
};
</script>

<style scoped>
  .card {
    padding: 40px 10px;
  }
  .card-link {
    text-transform: capitalize;
    height: 14vw;
    width:18vw;
  }
</style>